/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilitiesTrendSummary {
    getFixupPrototypeFunction() { return InfraVulnerabilitiesTrendSummary.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilitiesTrendSummary>): InfraVulnerabilitiesTrendSummary {
        let obj = Object.assign(new InfraVulnerabilitiesTrendSummary(), model);
        InfraVulnerabilitiesTrendSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilitiesTrendSummary>): InfraVulnerabilitiesTrendSummary {
        if (!model) return null;
        return InfraVulnerabilitiesTrendSummary.newInstance(<InfraVulnerabilitiesTrendSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilitiesTrendSummary) {
        if (!obj) return;

        models.InfraVulnerabilitiesTrendSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilitiesTrendSummary): boolean {
        Object.setPrototypeOf(obj, InfraVulnerabilitiesTrendSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (typeof this.date === "string") {
            this.date = new Date(<string><any>this.date);
        }
    }

    /**
     * Date of the time period
     */
    date: Date;

    /**
     * Severity of the Vulnerability
     */
    severity: models.Severity;

    /**
     * Count of vulnerabilities for the given date and severity
     */
    count: number;

}
